import type { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

const StyledDropdownWrapper = styled.div<{ $isOpen: boolean; $headerHeight: number }>`
  position: fixed;
  top: ${({ $headerHeight }) => `${$headerHeight}px`};
  left: 0;
  bottom: 0;
  z-index: 999;
  width: 100vw;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  background: rgba(0, 0, 0, 0.3);
`;

const StyledDropdown = styled.div<{ $isOpen: boolean; $headerHeight: number }>`
  position: relative;
  width: 100%;
  background: #272356;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 100%;
  overflow-y: auto;

  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0)' : 'translateY(-10px)')};
  transition:
    opacity 0.2s,
    visibility 0.2s,
    transform 0.2s;
`;

const StyledDropdownContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  padding: 32px;
`;

type MenuDropDownProps = {
  isOpen: boolean;
  onClick?: () => void;
  headerHeight: number;
};

export const MenuDropDown = ({ isOpen, children, onClick, headerHeight }: PropsWithChildren<MenuDropDownProps>) => (
  <StyledDropdownWrapper $isOpen={isOpen} $headerHeight={headerHeight} onClick={onClick}>
    <StyledDropdown $isOpen={isOpen} $headerHeight={headerHeight}>
      <StyledDropdownContent>{children}</StyledDropdownContent>
    </StyledDropdown>
  </StyledDropdownWrapper>
);
